<table mat-table [dataSource]="dataSource" class="clickable-table" matSort style="width: 100%;" matSortActive="name"
  matSortDirection="asc">

  <!-- name Column -->
  <ng-container matColumnDef="name">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header style="margin-top: 5px;">
        {{'label.name' | translate}}
      </div>
      <mat-form-field class="filter" floatLabel="never">
        <mat-label>{{'label.search' | translate}}</mat-label>
        <input matInput [formControl]="nameFilter" #search value="">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.name }}</span>
    </td>
  </ng-container>

  <!-- paco Column -->
  <ng-container matColumnDef="paco">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header style="margin-top: 5px;">
        {{'label.paco' | translate}}
      </div>
      <input type="checkbox" style="margin-top: 20px;
      margin-bottom: 10px;
      margin-left: 5px;" [indeterminate]="filterValues.onlyPacoIndeterminate" [checked]="filterValues.onlyPacoCheck"
        (click)="click(filterValues)" />
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-icon>{{ element.isPaco ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="top-action">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-button (click)="onCreateNewSite()">
        <mat-icon>add</mat-icon>{{ 'button.add-new-site' | translate }}
      </button>
    </th>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['top-action']"> </tr>
  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>